// extracted by mini-css-extract-plugin
export default {"layout":"layout____7kyU","header":"header___anpMw","subheader":"subheader___XLA39","description":"description___NOPpg"};